<template>
  <el-form class="text-control" :model="control" label-width="70px">
    <el-form-item prop="name">
      <template slot="label">
        <span class="require-flag">*</span>
        名称
      </template>
      <el-input v-model="control.name"></el-input>
    </el-form-item>
    <el-form-item>
      <template slot="label">默认值</template>
      <default-val-input
        :key="control._cid"
        :cur-control="control"
        :sheet="sheet"
        :available-sheet-map="availableSheetMap"
        :value="control.defaultVal"
      ></default-val-input>
    </el-form-item>
    <el-form-item prop="description">
      <template slot="label">提示</template>
      <el-input v-model="control.hint"></el-input>
    </el-form-item>
    <el-form-item prop="description">
      <template slot="label">描述</template>
      <el-input v-model="control.description"></el-input>
    </el-form-item>
    <el-form-item prop="lenLimit">
      <template slot="label">限定字数</template>
      <div>
        <el-checkbox :value="!_.isEmpty(control.lenLimit)" @input="changeLenLimit"></el-checkbox>
      </div>
      <template v-if="!_.isEmpty(control.lenLimit)">
        <el-input-number
          :value="control.lenLimit[0] === null ? undefined : control.lenLimit[0]"
          @input="$set(control.lenLimit, 0, $event)"
          placeholder="最小值"
          :controls="false"
          :max="control.lenLimit[1] === null ? Infinity : control.lenLimit[1]"
          size="small"
          style="width: 40%"
        ></el-input-number>
        <span>—</span>
        <el-input-number
          :value="control.lenLimit[1] === null ? undefined : control.lenLimit[1]"
          @input="$set(control.lenLimit, 1, $event)"
          placeholder="最大值"
          :controls="false"
          :min="control.lenLimit[0] === null ? -Infinity : control.lenLimit[0]"
          size="small"
          style="width: 40%"
        ></el-input-number>
      </template>
    </el-form-item>
    <el-form-item prop="format">
      <template slot="label">限定格式</template>
      <div>
        <el-checkbox :value="!!control.regex" @input="changeRegex"></el-checkbox>
      </div>
      <div v-if="control.regex" class="format">
        <div>{{ regexName }}</div>
        <el-button type="text" @click="openFormatDialog">编辑</el-button>
      </div>
    </el-form-item>
    <!-- 新增移动端扫码字段 -->
    <el-form-item prop="scanType">
      <template slot="label">扫码录入</template>
      <div>
        <el-checkbox :value="control.scanType !== 'NONE'" @input="changeScanType"></el-checkbox>
      </div>
      <template v-if="control.scanType !== 'NONE'">
        <el-select v-model="control.scanType">
          <el-option
            v-for="item in scanTypes"
            :key="item.value"
            :lable="item.label"
            :value="item.label"
          ></el-option>
        </el-select>
        <el-input v-model="control.scanRegex" placeholder="请输入可录入格式(正则)"></el-input>
      </template>
    </el-form-item>
    <el-form-item prop="required">
      <template slot="label">必填</template>
      <el-checkbox v-model="control.required" :disabled="control.main"></el-checkbox>
    </el-form-item>
    <el-form-item prop="display">
      <template slot="label">显示</template>
      <el-checkbox v-model="control.display" :disabled="control.main"></el-checkbox>
    </el-form-item>
    <el-form-item prop="disabled">
      <template slot="label">不可编辑</template>
      <el-checkbox v-model="control.disabled"></el-checkbox>
    </el-form-item>
    <el-form-item prop="main">
      <template slot="label">标题</template>
      <el-checkbox v-model="control.main" @change="checkChange($event)"></el-checkbox>
    </el-form-item>
    <el-form-item prop="main">
      <template slot="label">唯一</template>
      <el-checkbox v-model="control.unique"></el-checkbox>
    </el-form-item>
    <format-dialog
      ref="formatSetting"
      :regex="control.regex"
      @submit="changeFormat"
      :commonExpressions="commonExpressions"
    ></format-dialog>
  </el-form>
</template>

<script>
import {
  commonExpressions,
  codeTypes,
  scanTypes
} from "@/views/Backend/AdminEdit/Sheet/Field/detail-setting-content/control-setting/static"
import DefaultValInput from "@/views/Backend/AdminEdit/Sheet/Field/detail-setting-content/control-setting/default-val-input"
import FormatDialog from "@/views/Backend/AdminEdit/Sheet/Field/detail-setting-content/control-setting/FormatDialog"

export default {
  name: "text-control",
  components: { FormatDialog, DefaultValInput },
  props: {
    control: Object,
    sheet: Object,
    availableSheetMap: {
      type: Object
    }
  },
  data() {
    return {
      commonExpressions,
      codeTypes,
      scanTypes
    }
  },
  computed: {
    regexName() {
      let expression = this.commonExpressions.find(item => item.expression === this.control.regex)
      if (expression === undefined) return "自定义"
      else return expression.label
    }
  },
  methods: {
    changeLenLimit(selected) {
      this.control.lenLimit = selected ? [null, null] : []
    },
    changeScanType(val) {
      if (val) this.control.scanType = ""
      else this.control.scanType = "NONE"
    },
    checkChange(value) {
      this.$emit("checkboxChange", "main", value)
    },
    changeFormat(regex) {
      this.$set(this.control, "regex", regex)
      this.$set(this.control, "regexName", this.regexName)
    },
    changeRegex(value) {
      this.changeFormat("")
      if (value) this.openFormatDialog()
    },
    openFormatDialog() {
      this.$nextTick(() => {
        this.$refs.formatSetting?.open()
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.text-control {
  .format {
    display: flex;
    justify-content: space-between;
    background-color: #ebebeb;
    border-radius: 4px;
    padding: 0 15px;
  }
}
</style>
